import type { MenuItem as MenuItemType } from "@/data/menu";

export function MenuItem({ name, description, price, unit }: MenuItemType) {
  return (
    <div className="group/item flex items-baseline justify-between gap-4 border-b border-primary/10 pb-4">
      <div className="space-y-1">
        <p className="font-serif text-lg text-foreground group-hover/item:text-primary transition-colors">
          {name}
        </p>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      <div className="shrink-0 text-right">
        <p className="font-serif text-lg text-primary">{price}</p>
        {unit && (
          <p className="text-xs text-muted-foreground">{unit}</p>
        )}
      </div>
    </div>
  );
}
